import { render, staticRenderFns } from "./CustomInvestmentExposures.vue?vue&type=template&id=dea861d8&scoped=true"
import script from "./CustomInvestmentExposures.vue?vue&type=script&lang=ts"
export * from "./CustomInvestmentExposures.vue?vue&type=script&lang=ts"
import style0 from "./CustomInvestmentExposures.vue?vue&type=style&index=0&id=dea861d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea861d8",
  null
  
)

export default component.exports